<template>
    <!-- 弹出框查看 -->
    <div>
      <section class="dayincss" ref="print">
        <el-row>
          <el-col :span="4"><div class="bold-col">会议主体</div></el-col>
          <el-col :span="20"><div>{{rowdata.consultName}}</div></el-col>
        </el-row>
        <el-row>
          <el-col :span="4"><div class="bold-col">会议时间</div></el-col>
          <el-col :span="6"><div>{{rowdata.holdingTime}}</div></el-col>
          <el-col :span="6"><div class="bold-col">会议主持</div></el-col>
          <el-col :span="8"><div>{{rowdata.moderator}}</div></el-col>
        </el-row>
        <el-row>
          <el-col :span="4"><div class="bold-col">会议地点</div></el-col>
          <el-col :span="20"><div>{{rowdata.place}}</div></el-col>
        </el-row>
        <el-row>
          <el-col :span="1"><div class="bg-purple-light bold-col">序号</div></el-col>
          <el-col :span="3"><div class="bg-purple-light bold-col">人员类别</div></el-col>
          <el-col :span="3"><div class="bg-purple-light bold-col">参会人员</div></el-col>
          <el-col :span="3"><div class="bg-purple-light bold-col">手机号</div></el-col>
          <el-col :span="6"><div class="bg-purple-light bold-col">参与情况</div></el-col>
          <el-col :span="3"><div class="bg-purple-light bold-col">人员签到</div></el-col>
          <el-col :span="3"><div class="bg-purple-light bold-col">签到时间</div></el-col>
          <el-col :span="2"><div class="bg-purple-light bold-col">签退时间</div></el-col>
        </el-row>
        <!-- 两委代表 -->
        <el-row v-for="(item, index) in rowdata.representative" :key="index">
          <el-col :span="1"><div>{{index+1}}</div></el-col>
          <el-col :span="3"><div>{{item.type}}</div></el-col>
          <el-col :span="3"><div>{{item.name}}</div></el-col>
          <el-col :span="3"><div>{{item.phone}}</div></el-col>
          <el-col :span="6">
            <div>
              <el-radio-group :disabled="editDisabled" v-model="item.attend" @change="countNum('representative')">
                <el-radio label="0">参加</el-radio>
                <el-radio label="1">缺席</el-radio>
                <el-radio label="2">中途离场</el-radio>
              </el-radio-group>
            </div>
          </el-col>
          <el-col :span="3"><div></div></el-col>
          <el-col :span="3"><div></div></el-col>
          <el-col :span="2"><div></div></el-col>
        </el-row>
        <el-row>
          <el-col :span="4"><div class="bold-col">应到人数</div></el-col>
          <el-col :span="3"><div class="bold-col">{{rowdata.representativeNum}}</div></el-col>
          <el-col :span="3"><div class="bold-col">实到人数</div></el-col>
          <el-col :span="6"><div><span v-if="!showPrintBtn">{{rowdata.representativeYesNum}}</span></div></el-col>
          <el-col :span="3"><div class="bold-col">中途退场</div></el-col>
          <el-col :span="5"><div><span v-if="!showPrintBtn">{{rowdata.representativeHalfNum}}</span></div></el-col>
        </el-row>
        <!-- 两新代表 -->
        <div v-if="rowdata.organizationNum">
        <el-row v-for="(item, index) in rowdata.organization" :key="index">
          <el-col :span="1"><div>{{index+1+rowdata.representativeNum}}</div></el-col>
          <el-col :span="3"><div>{{item.type}}</div></el-col>
          <el-col :span="3"><div>{{item.name}}</div></el-col>
          <el-col :span="3"><div>{{item.phone}}</div></el-col>
          <el-col :span="6">
            <div>
              <el-radio-group :disabled="editDisabled" v-model="item.attend" @change="countNum('organization')">
                <el-radio label="0">参加</el-radio>
                <el-radio label="1">缺席</el-radio>
                <el-radio label="2">中途离场</el-radio>
              </el-radio-group>
            </div>
          </el-col>
          <el-col :span="3"><div></div></el-col>
          <el-col :span="3"><div></div></el-col>
          <el-col :span="2"><div></div></el-col>
        </el-row>
        <el-row>
          <el-col :span="4"><div class="bold-col">应到人数</div></el-col>
          <el-col :span="3"><div class="bold-col">{{rowdata.organizationNum}}</div></el-col>
          <el-col :span="3"><div class="bold-col">实到人数</div></el-col>
          <el-col :span="6"><div><span v-if="!showPrintBtn">{{rowdata.organizationYesNum}}</span></div></el-col>
          <el-col :span="3"><div class="bold-col">中途退场</div></el-col>
          <el-col :span="5"><div><span v-if="!showPrintBtn">{{rowdata.organizationHalfNum}}</span></div></el-col>
        </el-row>
        </div>
        <!-- 专业人士 -->
        <div v-if="rowdata.professionalNum">
        <el-row v-for="(item, index) in rowdata.professional" :key="index">
          <el-col :span="1"><div>{{index+1+rowdata.representativeNum+rowdata.organizationNum}}</div></el-col>
          <el-col :span="3"><div>{{item.type}}</div></el-col>
          <el-col :span="3"><div>{{item.name}}</div></el-col>
          <el-col :span="3"><div>{{item.phone}}</div></el-col>
          <el-col :span="6">
            <div>
              <el-radio-group :disabled="editDisabled" v-model="item.attend" @change="countNum('professional')">
                <el-radio label="0">参加</el-radio>
                <el-radio label="1">缺席</el-radio>
                <el-radio label="2">中途离场</el-radio>
              </el-radio-group>
            </div>
          </el-col>
          <el-col :span="3"><div></div></el-col>
          <el-col :span="3"><div></div></el-col>
          <el-col :span="2"><div></div></el-col>
        </el-row>
        <el-row>
          <el-col :span="4"><div class="bold-col">应到人数</div></el-col>
          <el-col :span="3"><div class="bold-col">{{rowdata.professionalNum}}</div></el-col>
          <el-col :span="3"><div class="bold-col">实到人数</div></el-col>
          <el-col :span="6"><div><span v-if="!showPrintBtn">{{rowdata.professionalYesNum}}</span></div></el-col>
          <el-col :span="3"><div class="bold-col">中途退场</div></el-col>
          <el-col :span="5"><div><span v-if="!showPrintBtn">{{rowdata.professionalHalfNum}}</span></div></el-col>
        </el-row>
        </div>
        <!-- 利益方 -->
        <div v-if="rowdata.interestPartyNum">
        <el-row v-for="(item, index) in rowdata.interestParty" :key="index">
          <el-col :span="1"><div>{{index+1+rowdata.representativeNum+rowdata.organizationNum+rowdata.professionalNum}}</div></el-col>
          <el-col :span="3"><div>{{item.type}}</div></el-col>
          <el-col :span="3"><div>{{item.name}}</div></el-col>
          <el-col :span="3"><div>{{item.phone}}</div></el-col>
          <el-col :span="6">
            <div>
              <el-radio-group :disabled="editDisabled" v-model="item.attend" @change="countNum('interestParty')">
                <el-radio label="0">参加</el-radio>
                <el-radio label="1">缺席</el-radio>
                <el-radio label="2">中途离场</el-radio>
              </el-radio-group>
            </div>
          </el-col>
          <el-col :span="3"><div></div></el-col>
          <el-col :span="3"><div></div></el-col>
          <el-col :span="2"><div></div></el-col>
        </el-row>
        <el-row>
          <el-col :span="4"><div class="bold-col">应到人数</div></el-col>
          <el-col :span="3"><div class="bold-col">{{rowdata.interestPartyNum}}</div></el-col>
          <el-col :span="3"><div class="bold-col">实到人数</div></el-col>
          <el-col :span="6"><div><span v-if="!showPrintBtn">{{rowdata.interestPartyYesNum}}</span></div></el-col>
          <el-col :span="3"><div class="bold-col">中途退场</div></el-col>
          <el-col :span="5"><div><span v-if="!showPrintBtn">{{rowdata.interestPartyHalfNum}}</span></div></el-col>
        </el-row>
        </div>
        <!-- 其它人员 -->
        <div v-if="rowdata.someoneElseNum">
        <el-row v-for="(item, index) in rowdata.someoneElse" :key="index">
          <el-col :span="1"><div>{{index+1+rowdata.representativeNum+rowdata.organizationNum+rowdata.professionalNum+rowdata.interestPartyNum}}</div></el-col>
          <el-col :span="3"><div>{{item.type}}</div></el-col>
          <el-col :span="3"><div>{{item.name}}</div></el-col>
          <el-col :span="3"><div>{{item.phone}}</div></el-col>
          <el-col :span="6">
            <div>
              <el-radio-group :disabled="editDisabled" v-model="item.attend" @change="countNum('someoneElse')">
                <el-radio label="0">参加</el-radio>
                <el-radio label="1">缺席</el-radio>
                <el-radio label="2">中途离场</el-radio>
              </el-radio-group>
            </div>
          </el-col>
          <el-col :span="3"><div></div></el-col>
          <el-col :span="3"><div></div></el-col>
          <el-col :span="2"><div></div></el-col>
        </el-row>
        <el-row>
          <el-col :span="4"><div class="bold-col">应到人数</div></el-col>
          <el-col :span="3"><div class="bold-col">{{rowdata.someoneElseNum}}</div></el-col>
          <el-col :span="3"><div class="bold-col">实到人数</div></el-col>
          <el-col :span="6"><div><span v-if="!showPrintBtn">{{rowdata.someoneElseYesNum}}</span></div></el-col>
          <el-col :span="3"><div class="bold-col">中途退场</div></el-col>
          <el-col :span="5"><div><span v-if="!showPrintBtn">{{rowdata.someoneElseHalfNum}}</span></div></el-col>
        </el-row>
        </div>
        <el-row>
          <el-col :span="24"><div class="bg-purple-light">合计</div></el-col>
        </el-row>
        <el-row>
          <el-col :span="6"><div class="bold-col">应到人数</div></el-col>
          <el-col :span="6"><div class="bold-col">实到人数</div></el-col>
          <el-col :span="6"><div class="bold-col">缺席人数</div></el-col>
          <el-col :span="6"><div class="bold-col">中途退场</div></el-col>
        </el-row>
        <el-row>
          <el-col :span="6"><div>{{rowdata.representativeNum+rowdata.professionalNum+rowdata.organizationNum+rowdata.interestPartyNum+rowdata.someoneElseNum}}</div></el-col>
          <el-col :span="6"><div><span v-if="!showPrintBtn">{{rowdata.representativeYesNum+rowdata.professionalYesNum+rowdata.organizationYesNum+rowdata.interestPartyYesNum+rowdata.someoneElseYesNum}}</span></div></el-col>
          <el-col :span="6"><div><span v-if="!showPrintBtn">{{rowdata.representativeNoNum+rowdata.professionalNoNum+rowdata.organizationNoNum+rowdata.interestPartyNoNum+rowdata.someoneElseNoNum}}</span></div></el-col>
          <el-col :span="6"><div><span v-if="!showPrintBtn">{{rowdata.representativeHalfNum+rowdata.professionalHalfNum+rowdata.organizationHalfNum+rowdata.interestPartyHalfNum+rowdata.someoneElseHalfNum}}</span></div></el-col>
        </el-row>
      </section>
      <el-form ref="form" :model="rowdata" label-width="140px" style="margin-top:30px;">
        <el-form-item label="签到表：">
          <el-upload :disabled="editDisabled" name="file" :limit="3" :on-success="uploadSuccess" :file-list="fileList" 
            :action="uploadUrl" :on-remove="handleRemove" :on-preview="handlePreview">
            <el-button v-if="showSaveBtn" size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <div class="boontbtn">
        <el-button v-if="showSaveBtn" type="primary" size="small" style="margin: 0 30px" @click="saveData">保存</el-button>
        <el-button v-if="showPrintBtn" type="primary" size="small" style="margin: 0 30px" @click="printeTable">打印</el-button>
        <el-button type="info" size="small" @click="closeDialog">关闭</el-button>
      </div>
    </div>
</template>
<script>
import request from "../../../../utils/request.js"
let token = JSON.parse(window.localStorage.getItem("user"));
export default {
  name: 'ViewSign',
  props: ["rowid"],
  data() {
    return {
      id: this.rowid,
      editDisabled: true,
      showSaveBtn: false,
      showPrintBtn: false,
      rowdata: {},
      fileList: [],
      uploadUrl: request.defaults.baseURL + '/consul/info/uplodfiles'
    };
  },
  methods: {
    //点击查看显示弹出层
    async getData() {
      this.rowdata = {
        representative: [],
        professional: [],
        organization: [],
        interestParty: [],
        someoneElse: []
      }
      if(this.id != ''){
        //获取编辑项的最新数据
        let fd = new FormData()
        fd.append("token", token)
        fd.append("id", this.id)
        var res = await request({
           url: "/admin/consul/info/findConsultById",
          method: "POST",
          data: fd
        })
        // console.log(res)
        if (res.code == 200) {
          //去除需要重新封装的字段
          this.$delete(res.content,'representative')
          this.$delete(res.content,'professional')
          this.$delete(res.content,'organization')
          this.$delete(res.content,'interestParty')
          this.$delete(res.content,'someoneElse')
          //将获取值合并到rowdata
          Object.assign(this.rowdata,res.content)
          // this.rowdata = res.content
          //待点评&已结束的状态，签到表只可查看 0-未开始 1-商议中 2-待点评 3-已结束
          if(this.rowdata.status=='2' || this.rowdata.status=='3'){
            this.showPrintBtn = false
            this.editDisabled = true
            this.showSaveBtn = false
          }else if(this.rowdata.status=='0' || this.rowdata.status==null){
            this.showPrintBtn = true
            this.editDisabled = true
            this.showSaveBtn = false
          }else{
            this.showPrintBtn = false
            this.editDisabled = false
            this.showSaveBtn = true
          }
          //上传数组显示
          this.fileList = []
          var temp = {}
          if(res.content.signinSurface != null && res.content.signinSurface != ""){
            var enclosureArr = res.content.signinSurface.split(',')
            enclosureArr.forEach((item,index) => {
              if(item != ''){
                temp = { name: '签到表'+index , url: item }
                this.fileList.push(temp)
              }
            })
          }
          // console.log(this.rowdata.consultRelationList)
          //拆分consultRelation人员关系字段
          if(this.rowdata.consultRelationList.length > 0){
            var temp = {}
            var index = 1
            this.rowdata.consultRelationList.forEach(item => {
              temp = {id: item.id, attend: item.attend, type: item.persongTypeName, name: item.name, phone: item.phone}
              if(item.persongType == 'Representative'){
                this.rowdata.representative.push(temp)
              }else if(item.persongType == 'Professional'){
                this.rowdata.professional.push(temp)
              }else if(item.persongType == 'Organization'){
                this.rowdata.organization.push(temp)
              }else if(item.persongType == 'InterestParty'){
                this.rowdata.interestParty.push(temp)
              }else if(item.persongType == 'SomeoneElse'){
                this.rowdata.someoneElse.push(temp)
              }
            })
          }
          this.rowdata.representativeNum = this.rowdata.representative.length
          this.countNum('representative')
          this.rowdata.professionalNum = this.rowdata.professional.length
          this.countNum('professional')
          this.rowdata.organizationNum = this.rowdata.organization.length
          this.countNum('organization')
          this.rowdata.interestPartyNum = this.rowdata.interestParty.length
          this.countNum('interestParty')
          this.rowdata.someoneElseNum = this.rowdata.someoneElse.length
          this.countNum('someoneElse')
        }else{
          this.rowdata = {}
          console.log(res.code + '：' +res.message)
          this.$message({
            message: "数据项加载异常",
            type: "error"
          })
        }
      }else{
        this.$message({
          message: "数据传输异常",
          type: "error"
        })
        this.rowdata = {}
        this.$emit('func',[])
      }
    },
    //审批接口
    printeTable () {
      this.$print(this.$refs.print);
    },
    //点击时，更新签到状态
    countNum(flag) {
      if(flag == 'representative'){
        this.rowdata.representativeYesNum = 0
        this.rowdata.representativeNoNum = 0
        this.rowdata.representativeHalfNum = 0
        this.rowdata.representative.forEach(item => {
          if(item.attend == '0'){ //实到
            this.rowdata.representativeYesNum++
          }else if(item.attend == '1'){  //缺席
            this.rowdata.representativeNoNum++
          }else if(item.attend == '2'){  //中途退场
            this.rowdata.representativeHalfNum++
          }
        })
      }else if(flag == 'professional'){
        this.rowdata.professionalYesNum = 0
        this.rowdata.professionalNoNum = 0
        this.rowdata.professionalHalfNum = 0
        this.rowdata.professional.forEach(item => {
          if(item.attend == '0'){ //实到
            this.rowdata.professionalYesNum++
          }else if(item.attend == '1'){  //缺席
            this.rowdata.professionalNoNum++
          }else if(item.attend == '2'){  //中途退场
            this.rowdata.professionalHalfNum++
          }
        })
      }else if(flag == 'organization'){
        this.rowdata.organizationYesNum = 0
        this.rowdata.organizationNoNum = 0
        this.rowdata.organizationHalfNum = 0
        this.rowdata.organization.forEach(item => {
          if(item.attend == '0'){ //实到
            this.rowdata.organizationYesNum++
          }else if(item.attend == '1'){  //缺席
            this.rowdata.organizationNoNum++
          }else if(item.attend == '2'){  //中途退场
            this.rowdata.organizationHalfNum++
          }
        })
      }else if(flag == 'interestParty'){
        this.rowdata.interestPartyYesNum = 0
        this.rowdata.interestPartyNoNum = 0
        this.rowdata.interestPartyHalfNum = 0
        this.rowdata.interestParty.forEach(item => {
          if(item.attend == '0'){ //实到
            this.rowdata.interestPartyYesNum++
          }else if(item.attend == '1'){  //缺席
            this.rowdata.interestPartyNoNum++
          }else if(item.attend == '2'){  //中途退场
            this.rowdata.interestPartyHalfNum++
          }
        })
      }else if(flag == 'someoneElse'){
        this.rowdata.someoneElseYesNum = 0
        this.rowdata.someoneElseNoNum = 0
        this.rowdata.someoneElseHalfNum = 0
        this.rowdata.someoneElse.forEach(item => {
          if(item.attend == '0'){ //实到
            this.rowdata.someoneElseYesNum++
          }else if(item.attend == '1'){  //缺席
            this.rowdata.someoneElseNoNum++
          }else if(item.attend == '2'){  //中途退场
            this.rowdata.someoneElseHalfNum++
          }
        })
      }
      //确认渲染
      let updateData = {
          representativeYesNum: this.rowdata.representativeYesNum,
          representativeNoNum: this.rowdata.representativeNoNum,
          representativeHalfNum: this.rowdata.representativeHalfNum,
          professionalYesNum: this.rowdata.professionalYesNum,
          professionalNoNum: this.rowdata.professionalNoNum,
          professionalHalfNum: this.rowdata.professionalHalfNum,
          organizationYesNum: this.rowdata.organizationYesNum,
          organizationNoNum: this.rowdata.organizationNoNum,
          organizationHalfNum: this.rowdata.organizationHalfNum,
          interestPartyYesNum: this.rowdata.interestPartyYesNum,
          interestPartyNoNum: this.rowdata.interestPartyNoNum,
          interestPartyHalfNum: this.rowdata.interestPartyHalfNum,
          someoneElseYesNum: this.rowdata.someoneElseYesNum,
          someoneElseNoNum: this.rowdata.someoneElseNoNum,
          someoneElseHalfNum: this.rowdata.someoneElseHalfNum
        }
      this.rowdata = Object.assign({},this.rowdata,updateData)
    },
     //上传
    handleExceed(files, fileList) {
      var selected = files.length
      var totalselected = selected + fileList.length
      this.$message.warning("当前限制选择3个文件，本次选择了"+selected+"个文件，共选择了"+totalselected+"个文件")
    },
    //附件预览
    handlePreview(file) {
      window.open(file.url);
    },
    //确保每次只能上传一个文件，可多次上传
    uploadSuccess(response, file, fileList) {
      // console.log(response)
      if(response.code == 200){
        this.fileList.push({name: response.content.name, url: response.content.path})
      }
    },
    handleRemove(file, fileList) {
      this.fileList = fileList
    },
    //保存到数据库
    async saveData() {
      let fd = new FormData()
      fd.append("token", token)

      if(this.fileList.length > 0){
        this.rowdata.signinSurface = ''
        this.fileList.forEach(item => {
          this.rowdata.signinSurface = this.rowdata.signinSurface + ',' + item.url
        })
      }
      var consultRelation = []
      consultRelation = consultRelation.concat(this.rowdata.representative)
      consultRelation = consultRelation.concat(this.rowdata.professional)
      consultRelation = consultRelation.concat(this.rowdata.organization)
      consultRelation = consultRelation.concat(this.rowdata.interestParty)
      consultRelation = consultRelation.concat(this.rowdata.someoneElse)
      let params = JSON.stringify(
        {persongid: this.rowdata.id, signinSurface: this.rowdata.signinSurface, consultRelationLists: consultRelation}
      );
      fd.append("uploadSign", params)
      console.log(params)
      var res = await request({
         url: "/admin/consul/info/uploadSign",
        method: "POST",
        data: fd
      });
      if (res.code == 200) {
        this.$message({
          message: '签到表上传成功',
          type: "success"
        });
        this.$emit('func',[])
      }else{
        console.log(res)
        this.$message({
            message: "上传失败：" + res.message,
            type: "error"
          });
      }
    },
    closeDialog() {
      this.$emit('func',[])
    }
  },
  mounted() {
    // this.getData()
  },
  beforeDestroy () {
  }
};
</script>

<style lang="less" scoped>
.el-row {
  border:1px solid #ccc;
  border-bottom: 0px;
  &:last-child {
    margin-bottom: 0;
    border-bottom: 1px solid #ccc;
  }
}
.el-col {
  border-right: 1px solid #ccc;
  &:last-child {
    margin-bottom: 0;
    border-right: 0px;
  }
  div {
    min-height: 36px;
    line-height: 36px;
    text-align: center;
  }
}
.bg-purple-light {
  background: #e5e9f2;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.bold-col {
  font-weight: bold;
}
.boontbtn {
  margin-top: 30px;
  display: flex;
  justify-content: center;
}
</style>